<template>
  <div>
    <h3 class="mb-3">{{ title }}</h3>

    <v-alert color="grey darken-1" border="left" text dense class="text-caption">
      Sélectionnez d’abord la table, puis configurez les filtres et les champs retournés.
      Donnez un alias explicite aux valeurs destinées à l’affichage.
    </v-alert>

    <!-- La table sélectionnée alimente les constructeurs Filtre et Fields. -->
    <v-autocomplete
      :value="config.table"
      :items="tables"
      label="Table ciblée"
      outlined
      dense
      clearable
      @input="change('table', $event || '')"
    />

    <!-- Ces deux composants éditent directement les arbres JSON de la requête. -->
    <template v-if="config.table">
      <v-tabs v-model="queryTab" grow background-color="grey lighten-4" class="mt-3">
        <v-tab>Champs</v-tab>
        <v-tab>Filtres et relations</v-tab>
      </v-tabs>
      <v-tabs-items v-model="queryTab">
        <v-tab-item class="pt-3">
          <div class="text-caption grey--text text--darken-1 mb-2">
            Ces champs et leurs alias alimentent les constructions visuelles du module.
          </div>
          <Fields :modalKey="modalKey" :page="page" :champs="config.champs" :filter="config.filtre" :table="config.table" />
        </v-tab-item>
        <v-tab-item class="pt-3">
          <div class="text-caption grey--text text--darken-1 mb-2">
            Limitez les lignes au contexte de la page et ajoutez ici les jointures nécessaires.
          </div>
          <Filtre :page="page" :filtre="config.filtre" :table="config.table" />
        </v-tab-item>
      </v-tabs-items>
    </template>

  </div>
</template>

<script>
import { admin } from '../mixins'

export default {
  name: 'RepartitionQueryEditor',
  mixins: [admin],
  props: {
    title: String,
    config: Object,
    tables: Array,
    page: [String, Number],
    modalKey: [String, Number],
  },
  data: () => ({ queryTab: 0 }),
  methods: {
    // Une nouvelle référence est émise pour ne pas modifier directement la prop.
    change(key, value) {
      this.$emit('change', { ...this.config, [key]: value })
    },
  },
}
</script>
